<template>
    <div class="bg-next-gray-md mb-3 flex items-stretch p-3 gap-3">
        <div class="basis-1/3 flex flex-col justify-between">
            <span class="font-bold">Nome</span>
            <span>{{ c.full_name }}</span>
        </div>
        <div class="basis-1/3 flex flex-col justify-between">
            <span class="font-bold">Denominazione azienda</span>
            <span>{{ c.denominazione_azienda }}</span>
        </div>
        <div class="basis-1/3 flex flex-col justify-between">
            <span class="font-bold">Telefono</span>
            <span>{{ c.telefono_1 }}</span>
            <span>{{ c.telefono_2 }}</span>
        </div>
        <div class="basis-1/3 flex flex-col justify-between">
            <span class="font-bold">Email</span>
            <span>{{ c.email }}</span>
        </div>
        <div class="basis flex flex-col self-center">
            <NextButton
                variant="outline-secondary"
                component="router-link"
                :to="{
                    name: 'DettaglioContatto',
                    params: { id: c.cliente_id, cid: c.id },
                }"
                class="sm:block py-1 px-3"
            >
                Vedi
            </NextButton>
        </div>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import NextButton from "@/components/NextButton.vue";

@Options({
    name: "ContattiSearchResult",
    components: { NextButton },
    props: {
        c: {
            type: Object,
            default: () => ({}),
        },
    },
})
export default class ContattiSearchResult extends Vue {
    c!: any;
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
